// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"0ca1a711","63":"f5a49d90","97":"4ccdfa44","109":"23f1d672","161":"b4b7b12b","485":"a4229981","619":"f0bbd7a2","624":"a3bbf307","653":"cba28714","671":"7644544e","936":"8436c3dc"}[chunkId] + ".chunk.js";
};